import { PlusIcon } from "lucide-react";

import { Link } from "@/components/Link";
import type { TestResult } from "../../types";
import { usePersistedAdminGridOptions } from "../../utils/gridState";
import { AdminGrid } from "../AdminGrid";
import { TableFilterRow } from "../TableFilterRow";

export function ResultsTable({
  results,
}: {
  results: TestResult[] | undefined;
}) {
  const { options, filterTextProps } = usePersistedAdminGridOptions(
    "results",
    results,
    [
      {
        field: "description",
        headerName: "Result",
        cellRenderer: (params) => (
          <Link
            to="/admin/results/$id/edit"
            params={{ id: encodeURIComponent(params.id) }}
          >
            {params.description}
          </Link>
        ),
        cellRendererParams: (params) => ({
          description: params.data.description,
          id: params.data.value,
        }),
      },
      {
        field: "value",
        headerName: "Code",
      },
    ],
    { sideBar: undefined },
  );

  return (
    <>
      <TableFilterRow inputProps={filterTextProps}>
        <Link to="/admin/results/new" asButton>
          <PlusIcon data-slot="icon" />
          Add test result
        </Link>
      </TableFilterRow>
      <AdminGrid {...options} />
    </>
  );
}
